<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="automations.length" class="list list-spaced rounded">
      <div class="flex py-2 font-medium text-sm bg-gray-200 uppercase text-gray-600">
        <div class="flex-1 px-4">When</div>
        <div class="flex-1 px-4">Then</div>
        <div class="px-4 w-20" />
      </div>

      <AutomationListLine
        v-for="line in automations"
        :key="line.uuid"
        :automation="line"
        @automation-edit="editAutomation"
        @automation-delete="confirmDeleteAutomation"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No automations found.</div>

    <template v-if="$membershipHasPermissionTo('edit projects') && automation">
      <portal v-if="isActionDelete" to="app-dialog">
        <BaseDialogDelete
          danger
          :custom-classes="'max-w-md'"
          @closed="resetAction"
          @confirmed="$emit('automation-delete', automation.uuid)"
        />
      </portal>

      <portal v-else-if="isActionEdit" to="app-dialog">
        <AutomationModalEdit :automation="automation" @closed="resetAction" />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import AutomationListLine from './automationList/Line.vue';
import AutomationModalEdit from './ModalEdit.vue';

const ACTION_DELETE = 'delete';
const ACTION_EDIT = 'edit';

export default {
  components: {
    AutomationListLine,
    AutomationModalEdit,
  },

  props: {
    loading: Boolean,
    projectUuid: { type: String, required: true },
    automations: { type: Array, default: () => [] },
  },

  data() {
    return {
      pending: false,
      action: null,
    };
  },

  computed: {
    ...mapGetters('ui/automations', ['automation']),

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },
  },

  methods: {
    ...mapMutations('ui/automations', ['setCurrent']),

    confirmDeleteAutomation(automation) {
      this.setCurrent(automation.uuid);
      this.action = ACTION_DELETE;
    },

    editAutomation(automation) {
      this.setCurrent(automation.uuid);
      this.action = ACTION_EDIT;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },
  },
};
</script>
